<template>

  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">
        <div class="col-lg-4 text-center text-lg-start alignFix posRel">
          <div class="assistant">
            <div class="row assHead g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRav1.png"></div>
              <div class="col-8 txt"> Ilaria <div>✈ Servizio Clienti Rimborso al Volo</div>
              </div>
            </div>
            <div class="row assContent g-0">
              <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRimborsoalVolo.jpg"></div>
              <div class="col-10 txt"> Non abbiamo trovato la pagina che cercavi. Clicca su "inserisci nuova richiesta" per iniziare a compilare il tuo reclamo.</div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 bgWight formStyle posRel">
          <div class="headForm">
            <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.svg">
          </div>
          <div class="p-5">
            <div class="col-md-4 mx-auto mb-5 text-center">
              <h1 class="display-5">PAGINA NON TROVATA</h1>
            </div>
            <div class="col-md-4 mx-auto">
              <button type="submit" class="btn styleBtn mb-3 float-end" @click="inizia()">INSERISCI NUOVA RICHIESTA</button>
            </div>
          </div>
          <div class="p-4 p-md-4 ">
          </div>
        </div>
      </div>
    </div>
  </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>

</template>

<script>

import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
import {useStore} from "vuex";
export default {
  name: "A404Component",
  setup(){
    const store = useStore();
    return {
      pulisciStato: () => {
        store.dispatch('volo/commitPulisciStato');
        store.dispatch('compilazione/commitPulisciStato');
        store.dispatch('passeggeri/commitPulisciStato');
      }
    }
  },
  components:{
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
  },
  mounted() {
    window.scrollTo(0,0);
  },
  methods:{
    inizia(){
      this.pulisciStato();
      this.$router.push('/customers/it/flightsub/');
    }
  }
}
</script>

<style scoped>

</style>